import { render, staticRenderFns } from "./ModalDetailPerkin.vue?vue&type=template&id=699838cf&scoped=true&"
import script from "./ModalDetailPerkin.vue?vue&type=script&lang=js&"
export * from "./ModalDetailPerkin.vue?vue&type=script&lang=js&"
import style0 from "./ModalDetailPerkin.vue?vue&type=style&index=0&id=699838cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699838cf",
  null
  
)

export default component.exports